<data-tree [isSelectionDialog]="true"></data-tree>
